import type { DocNode } from '@atlaskit/adf-schema/doc';
import type { ConfluenceUpdatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';

import type { DocumentUpdateCommandProcessor } from '../../stream-processors/update-command-processor';
import type { AIFC_ADF_UPDATE_KEY } from '../../types/command-manager';
import { getAgentAttribution } from '../../utils/get-agent-attribution';
import type { PageUpdateStrategy } from '../page-update-strategy';

type AdfUpdatePayload = Extract<
	ConfluenceUpdatePageCommandProperties,
	{ key: typeof AIFC_ADF_UPDATE_KEY }
>;

export class AdfUpdateStrategy implements PageUpdateStrategy {
	constructor(private processor: DocumentUpdateCommandProcessor) {}

	async process(payload: ConfluenceUpdatePageCommandProperties): Promise<void> {
		const {
			data,
			isStreamComplete,
			traceId,
			singleInstrumentationId,
			agentName,
			agentId,
			agentIdentityAccountId,
			isInlineEdit,
			agentNamedId,
			agentType,
		} = payload as AdfUpdatePayload;
		const agentAttribution = getAgentAttribution({ agentType, agentIdentityAccountId });
		await this.processor.streamChunk(
			data.toolCalls,
			isStreamComplete,
			traceId,
			singleInstrumentationId,
			agentName !== undefined
				? {
						agentName,
						agentId,
						agentIdentityAccountId,
						agentNamedId,
					}
				: undefined,
			isInlineEdit,
			agentAttribution,
		);
	}

	async finish(): Promise<DocNode | undefined> {
		await this.processor.finish();
		return undefined;
	}

	abort(reason?: 'user_abort' | 'aborted' | 'timeout'): void {
		this.processor.abort(reason);
	}
}
